import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setInitialState } from '../actions/auth-action';
import RegisterForm from './blocks/RegisterForm';


class Register extends Component {

  componentWillMount() {
    if (this.props.participantView.userShortView || !this.props.withServer || this.props.registrationClosed) {
      browserHistory.push('/');
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.setInitialState();
  }

  render() {
    if (this.props.participantView.userShortView || !this.props.withServer || this.props.registrationClosed) {
      browserHistory.push('/');
    }

    return (
      <div>
        <RegisterForm/>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  participantView: state.participant.participantView,
  withServer: state.participant.withServer,
  registrationClosed: state.participant.registrationClosed
});

const mapDispatchToProps = (dispatch) => ({
  setInitialState: bindActionCreators(setInitialState, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);


// WEBPACK FOOTER //
// ./src/register-page/Register.js